var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReplaceDocIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0.998047L6.5 1.99577L6.4704 2.02542M6.4704 2.02542L5.5 2.99805M6.4704 2.02542C6.31615 2.00734 6.15915 1.99805 6 1.99805C3.79086 1.99805 2 3.78891 2 5.99805C2 7.26125 2.58553 8.3877 3.5 9.12075M6.5 8.9981L5.5 9.95345L5.51485 9.9689M5.51485 9.9689C5.67385 9.98815 5.8358 9.99805 6 9.99805C8.20915 9.99805 10 8.2072 10 5.99805C10 4.73486 9.41445 3.60842 8.5 2.87536M5.51485 9.9689L6.5 10.9981",
    stroke: "#396BE5",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplaceDocIcon);
export default __webpack_public_path__ + "static/media/replaceDocIcon.cd23bf86af813f76c0ec58660c0cb88f.svg";
export { ForwardRef as ReactComponent };